import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { read, utils, writeFile } from 'xlsx';
import PublishIcon from '@material-ui/icons/Publish';
import {
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  Grid,
  FormControlLabel,
  TextField,
  Backdrop,
  CircularProgress,
  MenuItem,
  Stack,
  Checkbox
} from '@material-ui/core';
import Controls from '../controls/Controls';
import { baseUrl } from '../../utils/constants';
import { useSettingContext } from '../../context/setting_context';
import { useConstantsContext } from '../../context/constants_context';
import Category from '../icons/Category';

// const useStyles = makeStyles({
//   table: {
//     minWidth: 650
//   }
// });

const DependantsHist = () => {
  const m = moment();
  const { subsAmount, assureAmount } = useSettingContext();
  const { payCycles } = useConstantsContext();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState(0);
  const [cycleRefId, setCycleRefId] = useState(0);
  const [subAmount, setSubsAmount] = useState(subsAmount);
  const [addRevenue, setAddRevenue] = useState(false);
  const [monthDate, setMonthDate] = useState();
  const [insuranceAmount, setAssureAmount] = useState(assureAmount);
  const [exchangeRate, setExchangeRate] = useState(0);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [uploadedFile, setUploadedFile] = useState([]);
  const navigate = useNavigate();

  const currencies = [
    {
      value: 3,
      label: 'USD'
    },
    {
      value: 1,
      label: 'Zim Dollar'
    }
  ];

  const options = {
    raw: false,
    dateNF: 'yyyy-mm-dd' // Specify the date format string here
  };

  const handleImport = ($event) => {
    setLoading(true);
    const { files } = $event.target;
    if (files.length) {
      const file = files[0];
      // if (file.name.substring(5, 10) === '43580') {
      //   setCurrency(1);
      // } else {
      //   setCurrency(3);
      // }
      setMonthDate(
        new Date(
          file.name.substring(12, 16),
          (Number(file.name.substring(10, 12)) - 1).toString(),
          '01'
        )
      );
      console.log(
        'ipapa ipapa: ',
        new Date(
          file.name.substring(12, 16),
          (Number(file.name.substring(10, 12)) - 1).toString(),
          '01'
        )
      );
      setUploadedFile(file);
      const reader = new FileReader();
      reader.onload = (event) => {
        const wb = read(event.target.result, {
          type: 'binary',
          cellDates: true,
          cellNF: false,
          cellText: false
        });
        const sheets = wb.SheetNames;
        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]], options);
          // setRecords(rows);
          console.log('info:', rows);
          let newOptions = [];
          newOptions = rows.map((e) => ({
            Surname: e.Surname,
            FirstName: e.FirstName,
            IdNumber: e.IdNumber,
            DateOfBirth: e.DateOfBirth,
            MembershipNo: e.MembershipNo,
            RelationShip_ID: e.RelationShip_ID,
            TermDate: e.TermDate,
            MembershipStartDate: e.MembershipStartDate,
            Notes: e.Notes,
            BenefitType: e.BenefitType
          }));
          // console.log('newOptions:', newOptions);
          setRecords(newOptions);
          setLoading(false);
        } else {
          setLoading(false);
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const uploadDependantFile = () => {
    setLoading(true);
    const jsonClient = [];
    const jsonData = {
      employerRefId: 1,
      FileName: uploadedFile.name,
      upLoadDate: new Date(),
      upLoadedBy: sessionStorage.getItem('userRefId'),
      processState: 0,
      fileType: 1
    };
    jsonClient.push(jsonData);
    fetch(`${baseUrl}/api/client/SaveDependantFile`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          createTempDep(result.refId);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in saving SSB History File!: ${error}`, 'error');
        }
      );
  };

  // ----------------------Use Normal Upload

  const createTempDep = async (result) => {
    setLoading(true);
    const details = records.map((obj) => ({
      ...obj,
      DepFileRefId: result
    }));

    const jsonData = {
      details
    };

    const jsonClient = [];
    jsonClient.push(jsonData.details);
    fetch(`${baseUrl}/api/client/SaveDependantsImportDetail`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned tariff', res);
          setLoading(false);
          navigate('/clientportfolio/dependantsupload');
          notifyPopup(`Dependant Records Temp Saved Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Saving Dependants!: ${error}`, 'error');
        }
      );
  };
  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Card>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Typography variant="h4">Load Historical Dependants</Typography>
      <CardContent>
        <Stack direction="row" alignItems="center" justifyContent="center" sx={{ mb: 2 }}>
          <Box component="span" sx={{ p: 1, border: '1px solid grey', borderRadius: 1 }}>
            <input
              type="file"
              name="file"
              className="custom-file-input"
              id="inputGroupFile"
              required
              onChange={handleImport}
              // accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </Box>

          <Button
            type="button"
            variant="outlined"
            sx={{ minWidth: '180px', p: 1, px: 2, color: 'white', backgroundColor: '#000000' }}
            startIcon={<PublishIcon />}
            onClick={() => uploadDependantFile()}
          >
            Save File
          </Button>
        </Stack>

        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Surname</TableCell>
                <TableCell align="left">First Name</TableCell>
                <TableCell align="right">ECNumber</TableCell>
                <TableCell align="right">Date Of Birth</TableCell>
                <TableCell align="left">Id Number</TableCell>
                <TableCell align="left">BenefitType</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {records.map((row) => (
                <TableRow>
                  <TableCell align="left">{row.Surname}</TableCell>
                  <TableCell align="left">{row.FirstName}</TableCell>
                  <TableCell align="right">{row.MembershipNo}</TableCell>
                  <TableCell align="right">{row.DateOfBirth}</TableCell>
                  <TableCell align="left">{row.IdNumber}</TableCell>
                  <TableCell align="left">{row.BenefitType}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </CardContent>
    </Card>
  );
};

export default DependantsHist;
